import React, { Component, PropTypes } from 'react';
import { QuizDetailActions } from 'actions';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';
import { mixin, RefluxMixin } from 'Util';
import {
  List,
  ListItem,
  IconButton,
  TextField,
  Dialog,
  Table,
  TableHeader,
  TableRow,
  TableHeaderColumn,
  TableBody,
  TableRowColumn,
  FloatingActionButton,
  RaisedButton,
} from 'material-ui';
import moment from 'moment';
import { TaskResultList, RadioTaskResult } from 'components/Route/Task';
import TaskList from 'components/Route/Task/TaskList';
import * as Icons from 'components/Material/SvgIcons';
import { Units } from 'Css';
import { Colors } from 'Css';
import { translate as _l } from 'oxygen-i18n';

addTranslations({
  'en-US': {
    failed: 'Failed',
    success: 'Passed',
    courses: 'Courses',
    quiz: 'Quiz',
    export: 'Export Quiz',
    students: 'Students',
    collapse: 'Collapse',
    show: 'show',
    lock: 'Lock',
    unlock: 'Unlock',
    Lock: 'lock',
    Unlock: 'unlock',
    'Are you sure you would like to {0} the quiz':
      'Are you sure you would like to {0} the quiz'
  },
  'sv-SE': {
    failed: 'Icke godkänd',
    success: 'Godkänd',
    courses: 'Kurser',
    quiz: 'Quiz',
    export: 'Exportera Quiz',
    students: 'Studenter',
    collapse: 'Göm',
    show: 'visa',
    lock: 'Lås',
    unlock: 'Lås upp',
    Lås: 'låsa',
    'Lås upp': 'låsa upp',
    'Are you sure you would like to {0} the quiz':
      'Är du säker på att du vill {0} testet'
  }
});

const css = oxygenCss({
  root: {
    backgroundColor: Colors.theme.Light.card,
    display: 'flex',
    height: '100%',
    overflow: 'auto',
    '@phone': {
      padding: `${Units.base}px ${Units.base * 2}px`
    }
  },
  list: {
    maxWidth: '250px',
    borderRight: '1px solid rgba(0, 0, 0, 0.1)'
  },
  container: {
    width: '900px',
    padding: '0px 10px',
    margin: '30px auto',
    marginBottom: '0',
    overflow: 'auto'
  },
  active: {
    backgroundColor: '#01c9cb!important',
    color: '#fff!important'
  }
});

export default class Quizzes extends mixin(RefluxMixin, Component) {
  state = {
    userId: null,
    toggleLock: null,
    standardActions: [{ text: _l`cancel` }, { text: 'Unlock' }],
    courseOpen: true,
    pageOpen: false,
    studentOpen: true,
    value: '',
    limit: 20,
    currentDataUserId: null,
    currentCourseId: null,
    quizData: [],
    quizStudents: [],
    selectedPage: null,
    studentData: null,
    loading: false
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func,
  };

  constructQuiz = (quizData) => {
    const result = [];
    for (let key in quizData) {
      const quizConstructor = quizData;
      quizConstructor[key].id = key;
      result.push(quizConstructor[key]);
    }
    return result;
  };

  componentWillReceiveProps(nextProps) {
    const { quizData, quizStudents } = this.state;

    if (nextProps.studentData) {
      this.setState({ studentData: nextProps.studentData })
    }

    if (nextProps.quizStudents && nextProps.quizStudents.length > 0) {
      if (JSON.stringify(nextProps.quizStudents) !== JSON.stringify(quizStudents)) {
        this.setState({ quizStudents: nextProps.quizStudents });
      }
    }
    if (!quizData && nextProps.quizData && !Array.isArray(nextProps.quizData)) {
      this.setState({
        quizData: this.constructQuiz(nextProps.quizData),
        pageOpen: true
      })
    } else if (nextProps.quizData && !Array.isArray(nextProps.quizData)) {
      const propsKeys = Object.keys(nextProps.quizData);
      let stateKeys = [];

      if (quizData.length > 1) {
        quizData.forEach(el => {
          stateKeys.push(el.id)
        })
      } else if (quizData.length > 0) {
        stateKeys.push(quizData[0].id);
      }

      if (JSON.stringify(propsKeys) !== JSON.stringify(stateKeys)) {
        this.setState({ quizData: this.constructQuiz(nextProps.quizData), pageOpen: true, loading: false })
      } else {
        this.setState({ loading: true });
      }
    }
    if (quizData && Array.isArray(nextProps.quizData)) {
      this.setState({
        quizData: [],
        pageOpen: false
      })
    }
  }

  handleLoadMore = () => {
    const { currentCourseId, currentDataUserId, limit } = this.state;
    this.setState(state => ({ limit: state.limit + 20 }), () => {
      QuizDetailActions.selectUser(currentCourseId, currentDataUserId, 0, limit);
    });
  };

  handleChangeText = (e) => {
    this.setState({ value: e.target.value })
  };

  handleSelectPage = id => {
    this.setState({ selectedPage: id, studentData: null, currentDataUserId: null })
    // QuizDetailActions.selectPage(id);
  };

  handleSelectCourse = async id => {
    this.setState({ currentCourseId: id, selectedPage: null, studentData: null, currentDataUserId: null, pageOpen: false });
    QuizDetailActions.findTaskStudents(id);
    let pageStart = 0;
    const f = () => {
      return new Promise((resolve, reject) => {
        QuizDetailActions.selectCourse(id, null, (pageStart++) * 20, 20, resolve);
      });
    };

    while(true) {
      const data = await f();
      if(!Object.keys(data).length) break;
      const pageId = Object.keys(data)[0];
      const tasksKeys = Object.keys(data && data[pageId] && data[pageId].tasks);
      if (!tasksKeys.length) break;
    }
    this.setState({pageOpen: true});
  };

  handleSelectUser = id => {
    if (Array.isArray(this.state.quizData)) {
      const { selectedPage } = this.state;
      const quizData = JSON.parse(JSON.stringify(this.state.quizData));

      this.setState({ currentDataUserId: id, limit: 40, studentData: null });
      quizData.forEach(mockedQuiz => {
        if (mockedQuiz.id === selectedPage) {
          const result = [];
          const mockedTasks = mockedQuiz.tasks;
          const statsKeys = Object.keys(mockedQuiz.userStats).filter(el => Number(el) === id);
          const dataKeys = Object.keys(mockedQuiz.userdata).filter(el => Number(el) === id);
          const taskKeys = Object.keys(mockedQuiz.tasks);
          taskKeys.forEach(taskKey => {
            result.push(Object.assign({}, mockedQuiz.tasks[taskKey]));
          });
          const task = result
            .map(el => el.taskResults
              .filter(taskResult => taskResult.user.id === id)).filter(el => el.length > 0);

          taskKeys.forEach((taskKey, i) => {
            mockedTasks[taskKey].taskResults = task[i];
          });

          const studentData = {
            [mockedQuiz.id]: {
              id: mockedQuiz.id,
              page: mockedQuiz.page,
              tasks: mockedTasks,
              userStats: mockedQuiz.userStats[statsKeys[0]],
              userdata: mockedQuiz.userdata[dataKeys[0]]
            }
          };

          if (!mockedQuiz.userStats[statsKeys[0]] && !mockedQuiz.userdata[statsKeys[0]]) {
            this.setState({studentData: null})
          } else {
            this.setState({studentData: studentData})
          }
        }
      })
    }
  };

  handleOpen = (id, toggleLock) => {
    let actionText = toggleLock
      ? { text: _l`lock`, onClick: this.handleReset }
      : { text: _l`unlock`, onClick: this.handleReset };
    let standardActions = this.state.standardActions;

    standardActions[1] = { ...standardActions[1], ...actionText };
    this.setState({ userId: id, toggleLock, standardActions });

    this.refs.confirm.show();
  };

  handleReset = () => {
    const { userId, toggleLock, selectedPage, quizData } = this.state;
    QuizDetailActions.resetPage(userId, toggleLock, selectedPage, quizData);
    this.refs.confirm.dismiss();
  };

  handleChange = e => {
    if (e.target.name === 'students') {
      const { quizStudents } = this.props;

      this.setState({ quizStudents: quizStudents.filter(student => {
          if (student.name.toLowerCase().includes(e.target.value.toLowerCase())) {
            return student;
          }
        })
      });
    } else if (e.target.name === 'pages') {
      const { quizData } = this.props;
      const constructedQuizData = this.constructQuiz(quizData);

      this.setState({ quizData: constructedQuizData.filter(data => {
          if (data.page.name.toLowerCase().includes(e.target.value.toLowerCase())) {
            return data;
          }
        })
      })
    } else {
      this.setState({
        [e.target.name]: this.props[e.target.name].list.filter(k => {
          if (this.props[e.target.name].entities[k].page) {
            return this.props[e.target.name].entities[k].page.name
              .toLowerCase()
              .includes(e.target.value.toLowerCase());
          }
          return this.props[e.target.name].entities[k].name
            .toLowerCase()
            .includes(e.target.value.toLowerCase());
        })
      });
    }
  };

  courseChange = e => {
    this.setState({
      courseOpen: !this.state.courseOpen
    });
  };

  pageChange = e => {
    this.setState({
      pageOpen: !this.state.pageOpen
    });
  };

  studentChange = e => {
    this.setState({
      studentOpen: !this.state.studentOpen
    });
  };

  export = () => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let email = null;
    if (re.test(String(this.state.value).toLowerCase())) {
      email = this.state.value;
    }
    QuizDetailActions.export(email);
    this.refs.exportDialog.dismiss()
  };

  render() {
    const {
      currentDataUserId,
      studentData,
      selectedPage,
      standardActions,
      currentCourseId,
      quizStudents,
      studentOpen,
      pageOpen,
      courseOpen,
      quizData,
      loading,
    } = this.state;
    const courses = this.state.courses
      ? this.state.courses
      : this.props.courses.list;
    // const pages = this.state.pages ? this.state.pages : this.props.pages.list;
    // const students = this.state.students
    //   ? this.state.students
    //   : this.props.students.list;
    const exportActions = [
      { text: this.context.getIntlMessage('Cancel') },
      {
        text: this.context.getIntlMessage('Export'),
        onTouchTap: this.export,
        ref: 'submit'
      }
    ];
    return (
      <AppPage header={<RulerBar title="Quiz" />}>
        <div className={css.root}>
          <List
            style={{
              width: !courseOpen && '50px',
              backgroundColor: 'white',
              overflowY: 'auto',
              overflowX: 'hidden'
            }}
            className={css.list}
            subheaderStyle={{
              paddingRight: '16px',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              height: '50px',
              whiteSpace: 'nowrap'
            }}
          >
            <IconButton
              tooltip={courseOpen ? _l`collapse` : _l`show`}
              name="courseOpen"
              onClick={this.courseChange}
              style={{
                color: 'rgba(0,0,0,0.3)'
              }}
            >
              {courseOpen ? (
                <Icons.ActionSearch />
              ) : (
                  <Icons.ContentContentPaste />
                )}
            </IconButton>
            <TextField
              name="courses"
              style={{
                marginRight: 15,
                marginBottom: 5,
                width: 'calc(100% - 70px)',
                float: 'right',
                overflow: 'hidden'
              }}
              fullWidth
              onChange={this.handleChange}
              hintText={
                this.props.courses.selectedCourse
                  ? this.props.courses.entities[
                    this.props.courses.selectedCourse
                  ].name
                  : _l`courses`
              }
            />
            {courseOpen &&
              courses.map(q => (
                <ListItem
                  className={currentCourseId === q ? css.active : ''}
                  key={q}
                  style={{ fontSize: '14px' }}
                  onClick={() => this.handleSelectCourse(q)}
                  primaryText={this.props.courses.entities[q].name}
                />
              ))}
          </List>
          {(pageOpen || selectedPage) && (
            <List
              style={{
                width: !pageOpen && '50px',
                backgroundColor: 'white',
                overflowY: 'auto',
                overflowX: 'hidden'
              }}
              className={css.list}
              subheaderStyle={{
                paddingRight: '16px',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                height: '50px',
                whiteSpace: 'nowrap'
              }}
            >
              <IconButton
                tooltip={pageOpen ? _l`collapse` : _l`show`}
                name="pageOpen"
                onClick={this.pageChange}
                style={{
                  color: 'rgba(0,0,0,0.3)'
                }}
              >
                {pageOpen ? (
                  <Icons.ActionSearch />
                ) : (
                    <Icons.SocialPages />
                  )}
              </IconButton>
              <TextField
                name="pages"
                style={{
                  marginRight: 15,
                  marginBottom: 5,
                  width: 'calc(100% - 70px)',
                  float: 'right',
                  overflow: 'hidden'
                }}
                fullWidth
                onChange={this.handleChange}
                hintText={'Search page'}
              />
              {
                quizData.map(q => (
                  <ListItem
                    key={q.id}
                    className={selectedPage === q.id ? css.active : ''}
                    style={{ fontSize: '14px' }}
                    onClick={() => this.handleSelectPage(q.id)}
                    primaryText={q.page.name}
                  />
                ))
              }
            </List>
          )}
          {selectedPage && (
            <List
              style={{
                width: !studentOpen && '50px',
                backgroundColor: 'white',
                overflowY: 'auto',
                overflowX: 'hidden'
              }}
              className={css.list}
              subheaderStyle={{
                paddingRight: '16px',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                height: '50px',
                whiteSpace: 'nowrap'
              }}
            >
              <IconButton
                tooltip={studentOpen ? _l`collapse` : _l`show`}
                name="studentOpen"
                onClick={this.studentChange}
                style={{
                  color: 'rgba(0,0,0,0.3)'
                }}
              >
                {studentOpen ? (
                  <Icons.ActionSearch />
                ) : (
                    <Icons.SocialPersonOutline />
                  )}
              </IconButton>
              <TextField
                name="students"
                style={{
                  marginBottom: 5,
                  marginRight: 15,
                  width: 'calc(100% - 70px)',
                  float: 'right',
                  overflow: 'hidden'
                }}
                fullWidth
                onChange={this.handleChange}
                hintText={'Search students'}
              />

              {studentOpen &&
                quizStudents.map(student => {
                  let user, lockStatus;

                  quizData.forEach(page => {
                    if (page.id === selectedPage) {
                      Object.keys(page.userdata).forEach(key => {
                        if (Number(key) === student.id) {
                          user = page.userdata[key];
                          lockStatus = page.userdata[key] && page.userdata[key].locked;
                        }
                      })
                    }
                  });

                  const { courses } = this.props;
                  const repeatable =
                    courses.entities[currentCourseId] &&
                    courses.entities[currentCourseId].settings.quiz &&
                    courses.entities[currentCourseId].settings.quiz.pages &&
                    courses.entities[currentCourseId].settings.quiz.pages[selectedPage] &&
                    courses.entities[currentCourseId].settings.quiz.pages[selectedPage].repeatable;
                  const lockButton =
                    user && !lockStatus && !repeatable ? (
                      <IconButton
                        onClick={() => this.handleOpen(student.id, !lockStatus)}
                        tooltip="Lock Quiz"
                      >
                        <Icons.ActionLockOpen />
                      </IconButton>
                    ) : user && lockStatus && !repeatable ? (
                      <IconButton
                        onClick={() => this.handleOpen(student.id, !lockStatus)}
                        tooltip="Unlock Quiz"
                      >
                        <Icons.ActionLockOutline />
                      </IconButton>
                    ) : null;

                  return (
                    <ListItem
                      key={student.id}
                      className={currentDataUserId === student.id ? css.active : ''}
                      style={{ fontSize: '14px' }}
                      primaryText={student.name}
                      onClick={() => this.handleSelectUser(student.id)}
                      rightIconButton={lockButton}
                    />
                  );
                })
              }
            </List>
          )}
          {!currentDataUserId ? null : (
            <QuizResult
              handleLoadMore={this.handleLoadMore}
              title={''}
              data={
                studentData &&
                studentData[selectedPage] &&
                studentData[selectedPage].userdata &&
                studentData[selectedPage].userdata.pages &&
                studentData[selectedPage].userdata.pages[selectedPage]
                ?
                  studentData[selectedPage].userdata.pages[selectedPage]
                :
                  studentData &&
                    studentData[selectedPage] &&
                    studentData[selectedPage].userdata &&
                    studentData[selectedPage].userdata[currentDataUserId] &&
                    studentData[selectedPage].userdata[currentDataUserId].pages &&
                    studentData[selectedPage].userdata[currentDataUserId].pages[selectedPage]
                    ?
                    studentData[selectedPage].userdata[currentDataUserId].pages[selectedPage]
                    :
                    null
              }
              content={
                studentData &&
                studentData[selectedPage] &&
                studentData[selectedPage].tasks ? studentData[selectedPage].tasks : {}
              }
            />
          )}
        </div>
        <FloatingActionButton
          style={{
            position: 'fixed',
            right: 32,
            top: 35,
            zIndex: 10
          }}
          onClick={this.refs.exportDialog && this.refs.exportDialog.show}
        >
          <Icons.ActionLaunch />
        </FloatingActionButton>
        <Dialog
          title={`${standardActions[1].text} quiz`}
          actions={standardActions}
          ref="confirm"
        >
          {_l`Are you sure you would like to ${_l([standardActions[1].text])} the quiz`}
        </Dialog>
        <Dialog
          ref="exportDialog"
          title={_l`customExport`}
          actions={exportActions}
          actionFocus="export"
          dismissOnClickAway={true}
        >
          <TextField
            onChange={this.handleChangeText}
            floatingLabelText=""
            hintText="Email"
          />
        </Dialog>
      </AppPage>
    );
  }
}

class QuizResult extends Component {
  static contextTypes = {
    getIntlMessage: PropTypes.func,
  };

  render() {
    const { content, data, handleLoadMore } = this.props;
    return (
      <div className={css.container}>
        {data && (
          <Table
            height={150}
            fixedHeader={true}
            selectable={false}
            multiSelectable={false}
          >
            <TableHeader
              selectAllSelected={false}
              adjustForCheckbox={false}
              displaySelectAll={false}
              enableSelectAll={false}
            >
              <TableRow>
                <TableHeaderColumn
                  style={{ color: '#656565', textAlign: 'left' }}
                  tooltip={_l`Quiz Finnished tooltip`}
                >
                  {_l`Finnished`}
                </TableHeaderColumn>
                <TableHeaderColumn
                  style={{ color: '#656565', textAlign: 'left' }}
                  tooltip={_l`Quiz status tooltip`}
                >
                  {_l`Status`}
                </TableHeaderColumn>
                <TableHeaderColumn
                  style={{ color: '#656565' }}
                  tooltip={_l`Score`}
                >
                  {_l`Score`}
                </TableHeaderColumn>
                <TableHeaderColumn
                  style={{ color: '#656565' }}
                  tooltip={_l`Total tooltip`}
                >
                  {_l`Total`}
                </TableHeaderColumn>
                <TableHeaderColumn
                  style={{ color: '#656565' }}
                  tooltip={_l`Duration tooltip`}
                >
                  {_l`Duration`}
                </TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false} stripedRows={false}>
              {data
                .sort((a, b) => new Date(b.endTime) - new Date(a.endTime))
                .map(
                  ({ score, status, total, duration, startTime, endTime }) => (
                    <TableRow key={startTime}>
                      <TableRowColumn>
                        {moment(endTime).fromNow()}
                      </TableRowColumn>
                      <TableRowColumn>
                        {status === 'QUIZ_SUCCESS' ? _l`success` : _l`failed`}
                      </TableRowColumn>
                      <TableRowColumn>{score}</TableRowColumn>
                      <TableRowColumn>{total}</TableRowColumn>
                      <TableRowColumn>
                        {millisToMinutesAndSeconds(duration)}
                      </TableRowColumn>
                    </TableRow>
                  )
                )}
            </TableBody>
          </Table>
        )}
        <TaskList
          tasks={Object.keys(content).reverse().map(t => content[t])}
          hasFilter
          tasksLoading={false}
          selected={null}
        />
        <RaisedButton
          onTouchTap={handleLoadMore}
          style={{
            margin: '20px auto',
          }}
          fullWidth
          backgroundColor={'#01c9cb'}
          labelColor="#FFF"
          label={this.context.getIntlMessage('loadMore')}
        />
      </div>
    );
  }
}

function millisToMinutesAndSeconds(millis) {
  var minutes = Math.floor(millis / 60000);
  var seconds = ((millis % 60000) / 1000).toFixed(0);
  return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
};



// WEBPACK FOOTER //
// ./src/js/components/Route/Quizzes.js